export type MusicalKeyItem = {
  label: string;
  value: string;
};

export const MusicalKeys: MusicalKeyItem[] = [
  { label: 'C major', value: 'c' },
  { label: 'Db major', value: 'c#' },
  { label: 'D major', value: 'd' },
  { label: 'Eb major', value: 'd#' },
  { label: 'E major', value: 'e' },
  { label: 'F major', value: 'f' },
  { label: 'F# major', value: 'f#' },
  { label: 'G major', value: 'g' },
  { label: 'Ab major', value: 'g#' },
  { label: 'A major', value: 'a' },
  { label: 'Bb major', value: 'a#' },
  { label: 'B major', value: 'b' },
  { label: 'C minor', value: 'cm' },
  { label: 'C# minor', value: 'c#m' },
  { label: 'D minor', value: 'dm' },
  { label: 'D# minor', value: 'd#m' },
  { label: 'E minor', value: 'em' },
  { label: 'F minor', value: 'fm' },
  { label: 'F# minor', value: 'f#m' },
  { label: 'G minor', value: 'gm' },
  { label: 'G# minor', value: 'g#m' },
  { label: 'A minor', value: 'am' },
  { label: 'Bb minor', value: 'a#m' },
  { label: 'B minor', value: 'bm' },
];

export const CompactMusicalKeys: MusicalKeyItem[] = [
  { label: 'C major / A minor', value: 'c' },
  { label: 'G major / E minor (1♯)', value: 'g' },
  { label: 'D major / B minor (2♯)', value: 'd' },
  { label: 'A major / F♯ minor (3♯)', value: 'a' },
  { label: 'E major / C♯ minor (4♯)', value: 'e' },
  { label: 'B major / G♯ minor (5♯)', value: 'b' },
  { label: 'F♯ major / D♯ minor (6♯)', value: 'f#' },
  { label: 'D♭ major / B♭ minor (5♭)', value: 'c#' },
  { label: 'A♭ major / F minor (4♭)', value: 'g#' },
  { label: 'E♭ major / C minor (3♭)', value: 'd#' },
  { label: 'B♭ major / G minor (2♭)', value: 'a#' },
  { label: 'F major / D minor (1♭)', value: 'f' },
];
